<template>
  <div class="pb-12 gold-types-page">
    <v-container fluid>
      <h2 class="title-text">Gold Filled Vs. Gold Plated</h2>
      <v-row>
        <v-col cols="12">
          <p>
            <v-img
              :src="require('@/assets/guidereference/gold.jpg')"
              alt="Gold comparison"
              max-width="100%"
              contain
            >
            </v-img>
          </p>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "GoldTypesPage",
}
</script>

<style>
@media screen and (max-width: 960px) {
  .gold-types-page {
    padding-top: 40px;
  }
}
</style>